import styled from 'styled-components';
import DataTable from '@/components/DataTable';

export const OwnershipDataTable = styled(DataTable)`
  table-layout: fixed;
  width: 100%;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};

  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
  }

  tr {
    ${({ theme }) => theme.typography.xSmall};
    height: ${({ theme }) => theme.x4spacePx}px;
  }

  caption {
    text-align: left;
  }
`;
